<template>
    <b-modal :id="modalId" title="Edit Task" hide-footer>
        <loading-screen :is-loading="isSaving"></loading-screen>
        <errors :error-list="serverErrors"></errors>

        <form @submit.prevent="updateTask">

            <div class="form-group mb-4">
                <label for="description">Description</label>
                <textarea v-model="updatedTask.description" name="description" id="description" rows="2"
                          class="form-control"></textarea>
            </div>

            <div class="form-group mb-4">
                <label for="deadline">Due By</label>
                <date-picker v-model="updatedTask.deadline" :config="datePickerOptions"></date-picker>
            </div>

            <div class="form-group mb-4">
                <label>Agent</label>
                <v-select v-model="updatedTask.agent_id" label="name"
                          :reduce="agent => agent.id"
                          :clearable="true"
                          :options="agents"></v-select>
            </div>

            <button type="submit" class="btn btn-itg-dark" :disabled="isSaving"
                    @click.prevent="updateTask">
                Update Task
            </button>

        </form>
    </b-modal>
</template>

<script>
    import axios from "axios";
    import Forms from "../../../../../../mixins/Forms";
    import Tasks from "../../../../../../mixins/Tasks";
    import {mapGetters} from "vuex";

    export default {
        name: "EditTaskModal",
        props: ['task'],
        components: {Tasks},
        data() {
            return {
                isSaving: false,
                serverErrors: [],
                updatedTask: {
                    description: this.task.description,
                    agent_id: this.task.agent_id,
                    deadline: null
                },
                datePickerOptions: {
                    format: 'DD/MM/YYYY HH:mm'
                }
            }
        },
        created() {
            if (this.task.deadline) {
                    this.updatedTask.deadline = moment.utc(this.task.deadline).tz(window.itgTimezone).format('DD/MM/YYYY HH:mm');
            }
        },
        mixins: [Forms],
        computed: {
            ...mapGetters('ticketViewer', {
                ticket: 'ticket',
                agents: 'agents'
            }),

            modalId() {
                return 'edit-task-' + this.task.id + '-modal';
            }
        },
        methods: {
            updateTask() {
                let vm = this;
                vm.serverErrors = [];
                vm.isSaving = true;

                axios.put(API_BASE + '/tickets/' + this.ticket.id + '/tasks/' + this.task.id, {
                    ...vm.updatedTask,
                    alert_minutes_before_deadline: this.updatedTask.deadline !== null ? this.updatedTask.alert_minutes_before_deadline : null,
                    deadline: vm.updatedTask.deadline ? moment.tz(this.updatedTask.deadline, 'DD/MM/YYYY HH:mm', window.itgTimezone).utc().format('YYYY-MM-DD HH:mm:ss') : null
                }).then(r => {
                    vm.isSaving = false;
                    vm.$emit('task-updated');
                    vm.$bvModal.hide(vm.modalId);
                }).catch(e => {
                    console.log(e);
                    vm.isSaving = false;
                    vm.setErrors(e);
                });
            }
        }
    }
</script>

<style scoped>

</style>
